/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/**
 * A `useNavigate`-shaped API for external (or hard) navigation. Use for any
 * absolute URL or intentional full app reload instead of the `window.history`
 * or `window.location` methods/assignments, so that we can prohibit their use
 * elsewhere.
 */
const externalNavigate = (
  url: string | URL,
  options: { replace?: boolean; state?: any } = {},
): void => {
  if (options.state) {
    if (options.replace) {
      window.history.replaceState(options.state, '', url)
    } else {
      window.history.pushState(options.state, '', url)
    }
  } else {
    if (options.replace) {
      window.location.replace(url)
    } else {
      window.location.assign(url)
    }
  }
}

export default externalNavigate
